<template>
  <div class="service-user-info-wrapper">
    <div class="header">
      <i class="avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"/>
      <span class="nickname">{{user.nickname}}</span>
      <router-link to="/service/pc/" class="create-btn" v-if="!isActivityEmpty">新建裂变活动</router-link>
    </div>
    <ul class="analytic-list">
      <li class="analytic-item">总计活动：<i>0</i>个</li>
      <li class="analytic-item">销售收入：<i>0</i>元</li>
      <li class="analytic-item">总计用户：<i>0</i>人</li>
      <li class="analytic-item">分销收入：<i>0</i>元</li>
    </ul>
  </div>
</template>

<script>
import defaultAvatar from '../../assets/default_avatar.png'

export default {
  name: 'UserInfo',
  props: {
    user: Object,
    isActivityEmpty: Boolean,
  },
  watch: {
    user: function () {
      if (this.user && !this.user.avatar) {
        this.user.avatar = defaultAvatar
      }
    }
  },
};
</script>

<style scoped lang="scss">
.service-user-info-wrapper {
  padding: 2px;
  background-color: #e51c23;

  .header {
    display: flex;
    align-items: center;
    padding: 5px 15px;
  }

  .avatar {
    width: 60px;
    height: 60px;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
  }

  .nickname {
    width: 0;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0 15px;
    font-size: 20px;
    line-height: 60px;
    color: #fff;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .analytic-list {
    margin: 0;
    padding: 0;
    list-style: none;
    background-color: #fff;
  }

  .analytic-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    &::before {
      content: '';
      position: absolute;
      top: 10px;
      right: 50%;
      bottom: 10px;
      width: 1px;
      background-color: #e6e6e6;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 30px;
      left: 30px;
      height: 1px;
      background-color: #e6e6e6;
    }
  }

  .analytic-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 40px;
    width: 48vw;
    flex-grow: 0;
    flex-shrink: 0;
    color: #101010;

    i {
      display: inline-block;
      font-style: normal;
      color: #e51c23;
      font-size: 18px;
      margin-right: 3px;
    }
  }

  .create-btn {
    color: #e51c23;
    text-decoration: none;
    font-size: 14px;
    line-height: 40px;
    border-radius: 20px;
    padding: 0 10px 0 30px;
    background-image: url('../../assets/h5/plus.png');
    background-size: 15px;
    background-repeat: no-repeat;
    background-position: 8px center;
    background-color: #fff;
  }
}
</style>
